<template>
  <div
    class="alert alert-warning text-center"
    v-if="error"
  >
    <div class="mb-2">
      <i class="fa fa-warning"></i>
    </div>
    {{ error }}
  </div>
  <div
    v-else-if="listMode"
    class="w-100 h-100"
  >
    <div class="d-flex justify-content-between m-2">
      <v-button
        icon="check-square"
        text="phrase.select_all"
        style-type="link"
        :disabled="researchItemsVisible.every((elem) => elem)"
        size="xs"
        @click="selectAll"
      />
      <v-button
        icon="bar-chart"
        text="phrase.show_chart"
        style-type="secondary"
        size="xs"
        @click="listMode = false"
      />
    </div>
    <table class="table table-bordered table-striped">
      <tr
        v-for="(researchItem, index) in researchItems"
        :key="researchItem.id"
        :class="{'bg-light': researchItemsVisible[index]}"
      >
        <td>
          <input
            v-if="researchItem.average"
            type="checkbox"
            v-model="researchItemsVisible[index]"
            :disabled="researchItem.research.uuid === research.uuid"
          />
        </td>
        <td :class="{'text-bold': researchItem.research.uuid === research.uuid}">
          {{ stringToPrettyDate(researchItem.research.start_date) }}
        </td>
        <td>
          <div
            class="text-bold"
            v-if="researchItem.research.uuid === research.uuid"
          >
            {{ researchItem.research.title }}
          </div>
          <router-link
            v-else
            :to="getResearchDashboardRoute(researchItem.research)"
          >
            {{ researchItem.research.title }}
          </router-link>
        </td>
        <td
          class="text-right"
        >
          <div
            class="badge badge-dark bg-cr-red-black"
            v-if="researchItem.average"
          >
            <i class="fa fa-star mr-1"></i>
            {{ researchItem.average.toFixed(2) }}
          </div>
          <div v-else>
            -
          </div>
        </td>
      </tr>
    </table>
  </div>
  <div
    class="w-100 h-100 p-2"
    v-else-if="researchItems && researchItems.length > 1"
  >
    <v-bar-chart
      :labels="labels"
      :data-sets="datasets"
      :show-legend="false"
      :truncate-y-labels="30"
      direction="horizontal"
      :extra-actions="extraActions"

      @show-list="listMode = true"
    />
  </div>
  <div
    class="text-muted text-center"
    v-else-if="researchItems"
  >
    <div class="mb-2">
      <i class="fa fa-info-circle"></i>
    </div>
    {{ $t('sentence.question_not_used_elsewhere') }}
  </div>
  <div v-else>
    <v-loader/>
  </div>
</template>

<script>
import {
  fetchResearchItemsForItem,
  makeFilterQueryParams,
} from '@/organisation/api';
import BarChart from '@/organisation/components/charts/BarChart.vue';
import Button from '@/common/components/Button.vue';
import Loader from '@/common/components/Loader.vue';
import { COLORS } from '@/common/utils/constants';
import { mapGetters } from 'vuex';
import { stringToPrettyDate } from '@/common/utils/formatting';

export default {
  name: 'ItemDataCompareWidget',
  components: {
    'v-bar-chart': BarChart,
    'v-button': Button,
    'v-loader': Loader,
  },
  props: {
    research: {
      type: Object,
      required: true,
    },
    researchItem: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      COLORS,
      error: null,
      listMode: false,
      researchItems: null,
      researchItemsVisible: null,
    };
  },
  computed: {
    ...mapGetters('researches', ['filters']),
    extraActions() {
      return [
        {
          icon: 'list',
          text: this.$t('phrase.show_list'),
          name: 'show-list',
        },
      ];
    },
    selectedResearchItems() {
      return this.researchItems.filter(
        (_, index) => (this.researchItemsVisible[index]),
      );
    },
    labels() {
      return this.selectedResearchItems.map(
        (researchItem) => `${researchItem.research.start_date}: ${researchItem.research.title}`,
      );
    },
    datasets() {
      return [
        {
          data: this.selectedResearchItems.map(
            (researchItem) => (researchItem.average.toFixed(1) || 0),
          ),
          backgroundColor: this.selectedResearchItems.map(
            (researchItem) => (
              researchItem.id === this.researchItem.id ? COLORS.red : COLORS.blue
            ),
          ),
        },
      ];
    },
  },
  methods: {
    stringToPrettyDate,
    selectAll() {
      this.researchItemsVisible = this.researchItems.map(() => true);
    },
    async fetchResearchesForItem() {
      const response = await fetchResearchItemsForItem(
        this.research.organisation.slug,
        this.researchItem.item.id,
        makeFilterQueryParams(this.filters),
      );
      this.researchItems = response.data.filter((researchItem) => researchItem.average !== null);
      if (!this.researchItemsVisible) {
        this.selectAll();
      }
    },
    getResearchDashboardRoute(research) {
      return { name: 'organisation-research-dashboard', params: { uuid: research.uuid } };
    },
  },
  created() {
    if (this.filters.researchItemFilters) {
      this.error = this.$t('sentence.filters_not_supported_for_compare');
    } else {
      this.fetchResearchesForItem();
    }
  },
};
</script>
